import React from 'react';
import styled from "@emotion/styled";
import { USE_IMAGE_PLACEHOLDERS } from "./constants/paths";
import { Paper } from "@mui/material";

export const getAssetPath = (url, size) => {
    if (USE_IMAGE_PLACEHOLDERS) {
        return `https://via.placeholder.com/${size}.png`;
    }

    return url;
};

export const ItemBlock = (props) => {

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));
    return <Item>{props.children}</Item>
}

export function formatDateYYYYMMDD(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 because January is 0
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export function getQueryParam(paramName, url = window.location.href) {
    const parsedUrl = new URL(url);
    return parsedUrl.searchParams.get(paramName);
}